"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASC_NOISE_CLUSTER_TYPES = exports.AscClusterType = void 0;
exports.isAscNoiseClusterType = isAscNoiseClusterType;
var AscClusterType;
(function (AscClusterType) {
    AscClusterType["SMART_MAIN"] = "SMART_MAIN";
    AscClusterType["SMART_NOISE"] = "SMART_NOISE";
    AscClusterType["CAPITALIZABLE_PROJECT_MAIN"] = "CAPITALIZABLE_PROJECT_MAIN";
    AscClusterType["CAPITALIZABLE_PROJECT_NOISE"] = "CAPITALIZABLE_PROJECT_NOISE";
    AscClusterType["DETERMINISTIC_HAS_ROOT"] = "DETERMINISTIC_HAS_ROOT";
    AscClusterType["DETERMINISTIC_NO_ROOT"] = "DETERMINISTIC_NO_ROOT";
    AscClusterType["MANUALLY_CREATED"] = "MANUALLY_CREATED";
    AscClusterType["MERGED"] = "MERGED";
})(AscClusterType || (exports.AscClusterType = AscClusterType = {}));
exports.ASC_NOISE_CLUSTER_TYPES = [
    AscClusterType.SMART_NOISE,
    AscClusterType.CAPITALIZABLE_PROJECT_NOISE,
];
function isAscNoiseClusterType(type) {
    return exports.ASC_NOISE_CLUSTER_TYPES.includes(type);
}
